export default "__VITE_ASSET__Dk8a$hZO__"